export const SET_CHATBOT_STATE = 'SET_CHATBOT_STATE'
